// extracted by mini-css-extract-plugin
module.exports = {"next-button":"AttachmentList_next-button__3haWH"};